// extracted by mini-css-extract-plugin
export default {"tabs":"BadgePage_tabs__R5UVP"};